import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useTranslation } from "react-i18next";
import { i18_SIGNUP } from "../../i18nReferences";
import logoLight from "../../public/images/KissCalLogoWithText-light.png";
import ColorModeContext from "../common/ColorModeContext";
import LanguageSelector from "../common/LanguageSelector";

/**
 * Toolbar component for the signup page
 * Provides language selection, theme toggle, and branding
 * Uses the ColorModeContext from the main App for theme switching
 */
const SignupToolbar = ({ lang, onChangeLocale }) => {
    const { t } = useTranslation([i18_SIGNUP]);
    const theme = useTheme();
    const colorMode = React.useContext(ColorModeContext);

    return (
        (<AppBar position="sticky">
            <Toolbar disableGutters>
                <Box
                    sx={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        mr: 1,
                        ml: 1,
                        gap: 1
                    }}>
                    <Box
                        sx={{
                            flex: "1",
                            padding: 1
                        }}>
                        <Box sx={{ height: { xs: "3em", sm: "4em", md: "5em" }, display: "flex" }}>
                            <img height="100%" src={logoLight} alt="kisscal-logo" />
                        </Box>
                        <Typography variant="h6" sx={{ display: { xs: "none", md: "flex" } }}>
                            {t("TOOLBAR_SUBTITLE")}
                        </Typography>
                    </Box>
                    <Box sx={{
                        flex: "0 0 Auto"
                    }}>
                        <LanguageSelector lang={lang} onChangeLocale={onChangeLocale} />
                    </Box>
                    <Box sx={{
                        flex: "0 0 Auto"
                    }}>
                        <IconButton color="inherit" onClick={colorMode.toggleColorMode}>
                            {theme?.palette.mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
                        </IconButton>
                    </Box>
                </Box>
            </Toolbar>
            <Box
                sx={{
                    mr: 1,
                    ml: 1,
                    display: { xs: "flex", md: "none" }
                }}>
                <Typography variant="h6">{t("TOOLBAR_SUBTITLE")}</Typography>
            </Box>
        </AppBar>)
    );
};

export default SignupToolbar;

